"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Label = _interopRequireDefault(require("../../Label/Label"));

var _Input = _interopRequireDefault(require("../Input"));

var _theming = require("../../../../theming");

var _themeContants = require("../../../../constants/themeContants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var BirthdateInput =
/*#__PURE__*/
function (_React$Component) {
  _inherits(BirthdateInput, _React$Component);

  function BirthdateInput(props) {
    var _this;

    _classCallCheck(this, BirthdateInput);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(BirthdateInput).call(this, props)); // create a ref to store the textInput DOM element

    _this.dayInput = _react["default"].createRef();
    _this.handleChangeDayInput = _this.handleChangeDayInput.bind(_assertThisInitialized(_this));
    _this.monthInput = _react["default"].createRef();
    _this.handleChangeMonthInput = _this.handleChangeMonthInput.bind(_assertThisInitialized(_this));
    _this.yearInput = _react["default"].createRef();
    _this.handleChangeYearInput = _this.handleChangeYearInput.bind(_assertThisInitialized(_this));
    _this.createDate = _this.createDate.bind(_assertThisInitialized(_this));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.handleComplete = _this.handleComplete.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(BirthdateInput, [{
    key: "handleChangeDayInput",
    value: function handleChangeDayInput(value) {
      this.handleChange();

      if (value.toString().length > 1) {
        this.monthInput.current.input.current.focus();

        if (this.monthInput.current.input.current.value.toString().length > 1 && this.yearInput.current.input.current.value.toString().length > 1) {
          this.handleComplete();
        } else {
          this.monthInput.current.input.current.focus();
        }
      }
    }
  }, {
    key: "handleChangeMonthInput",
    value: function handleChangeMonthInput(value) {
      this.handleChange();

      if (value.toString().length > 1) {
        if (this.dayInput.current.input.current.value.toString().length > 1 && this.yearInput.current.input.current.value.toString().length > 1) {
          this.handleComplete();
        } else {
          this.yearInput.current.input.current.focus();
        }
      }
    }
  }, {
    key: "handleChangeYearInput",
    value: function handleChangeYearInput(value) {
      this.handleChange();

      if (value.toString().length > 3) {
        if (this.dayInput.current.input.current.value.toString().length < 1) {
          this.dayInput.current.input.current.focus();
        } else if (this.monthInput.current.input.current.value.toString().length < 1) {
          this.monthInput.current.input.current.focus();
        } else {
          this.handleComplete();
        }
      }
    }
  }, {
    key: "createDate",
    value: function createDate(d, m, y) {
      return new Date(y.toString() + "-" + m.toString() + "-" + d.toString());
    }
  }, {
    key: "handleChange",
    value: function handleChange() {
      if (this.props.onChange) {
        this.props.onChange(this.dayInput.current.input.current.value.toString() + this.monthInput.current.input.current.value.toString() + this.yearInput.current.input.current.value.toString());
      }
    }
  }, {
    key: "handleComplete",
    value: function handleComplete() {
      this.props.onComplete && this.props.onComplete(this.createDate(this.dayInput.current.input.current.value, this.monthInput.current.input.current.value, this.yearInput.current.input.current.value));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          id = _this$props.id,
          name = _this$props.name,
          labels = _this$props.labels,
          variant = _this$props.variant,
          className = _this$props.className,
          autoFocus = _this$props.autoFocus,
          disabled = _this$props.disabled,
          onKeyDown = _this$props.onKeyDown,
          style = _this$props.style,
          pattern = _this$props.pattern,
          label = _this$props.label,
          onChange = _this$props.onChange,
          onComplete = _this$props.onComplete,
          ids = _this$props.ids,
          names = _this$props.names,
          rest = _objectWithoutProperties(_this$props, ["id", "name", "labels", "variant", "className", "autoFocus", "disabled", "onKeyDown", "style", "pattern", "label", "onChange", "onComplete", "ids", "names"]);

      console.log(_objectSpread2({}, rest));
      return _react["default"].createElement(Outer, {
        variant: variant,
        className: className,
        style: style
      }, label && _react["default"].createElement(_Label["default"], {
        id: id
      }, label), _react["default"].createElement(Container, {
        variant: variant
      }, _react["default"].createElement(_Input["default"], {
        label: labels && labels[0] && labels[0],
        placeholder: "dd",
        id: ids ? ids[0] ? ids[0] : "".concat(id, "Day") : "".concat(id, "Day"),
        name: names ? names[0] ? names[0] : "".concat(name, "Day") : "".concat(name, "Day"),
        type: "tel",
        ref: this.dayInput,
        onChange: function onChange(e) {
          return _this2.handleChangeDayInput(e.target.value);
        },
        variant: variant,
        autoFocus: autoFocus,
        disabled: disabled,
        onKeyDown: onKeyDown,
        pattern: pattern,
        "aria-labelledby": label && id
      }), _react["default"].createElement(_Input["default"], {
        label: labels && labels[1] && labels[1],
        placeholder: "mm",
        id: ids ? ids[1] ? ids[1] : "".concat(id, "Month") : "".concat(id, "Month"),
        name: "".concat(name, "Month"),
        type: "tel",
        ref: this.monthInput,
        onChange: function onChange(e) {
          return _this2.handleChangeMonthInput(e.target.value);
        },
        variant: variant,
        disabled: disabled,
        onKeyDown: onKeyDown,
        pattern: pattern,
        "aria-labelledby": label && id
      }), _react["default"].createElement(_Input["default"], {
        label: labels && labels[2] && labels[2],
        placeholder: "yyyy",
        id: ids ? ids[2] ? ids[2] : "".concat(id, "Year") : "".concat(id, "Year"),
        name: "".concat(name, "Year"),
        type: "tel",
        ref: this.yearInput,
        onChange: function onChange(e) {
          return _this2.handleChangeYearInput(e.target.value);
        },
        variant: variant,
        disabled: disabled,
        onKeyDown: onKeyDown,
        pattern: pattern,
        "aria-labelledby": label && id
      })));
    }
  }]);

  return BirthdateInput;
}(_react["default"].Component);

BirthdateInput.themeProps = {
  outer: {
    name: "BIRTHDATE_INPUT_OUTER_STYLE",
    description: "Outer style",
    type: _themeContants.themePropTypes.style
  },
  container: {
    name: "BIRTHDATE_INPUT_CONTAINER_STYLE",
    description: "Container style",
    type: _themeContants.themePropTypes.style
  }
};

var Outer = _styledComponents["default"].div.withConfig({
  displayName: "BirthdateInput__Outer",
  componentId: "sc-16ogba8-0"
})(["", ";"], (0, _theming.applyVariants)(BirthdateInput.themeProps.outer));

var Container = _styledComponents["default"].div.withConfig({
  displayName: "BirthdateInput__Container",
  componentId: "sc-16ogba8-1"
})(["display:flex;", ";"], (0, _theming.applyVariants)(BirthdateInput.themeProps.container));

BirthdateInput.propTypes = {
  variant: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  onComplete: _propTypes["default"].func,
  ids: _propTypes["default"].array.isRequired,
  labels: _propTypes["default"].array
};
BirthdateInput.defaultProps = {};
var _default = BirthdateInput;
exports["default"] = _default;